export default __webpack_public_path__ + "static/media/newpayLogoColor.7b1dd6b5.png";